export const Keys = {
  form: {
    rechteck: 'rechteck',
    kreisrund: 'kreisrund',
  },
  schliff: {
    rund: 'rund',
    standard: 'standard',
  },
};
